import { FC } from "react";

import { ChatChartProps } from "./types";

export const MultiseriesBarChart: FC<ChatChartProps> = ({ chartData }) => {
  console.info(chartData);

  return null;
};
